import styled from 'styled-components';
import {dFlexCenter} from '../../../globalVariables/GlobalFlex';

export type StatusColor = 'brand' | 'highlight' | 'scanned' | 'canceled' | 'past';

export const statusStripHeight = '40px';

export const statusStripPalette: Record<StatusColor, {bg: string; text: string}> = {
    brand: {
        bg: 'linear-gradient(to left, var(--primitive-turquoise-100) 42%, var(--primitive-turquoise-400) 120%)',
        text: 'var(--color-text-inverse-default)'
    },
    highlight: {
        bg: 'linear-gradient(to left, var(--primitive-yellow-100) 42%, var(--primitive-yellow-400) 120%)',
        text: 'var(--color-text-inverse-default)'
    },
    scanned: {
        bg: 'linear-gradient(to left, var(--color-state-warning-bg) 42%, var(--color-state-warning-main) 120%)',
        text: 'var(--primitive-orange-600)'
    },
    canceled: {
        bg: 'linear-gradient(to left, var(--color-state-error-bg) 42%, var(--color-state-error-main) 120%)',
        text: 'var(--primitive-red-600)'
    },
    past: {
        bg: 'linear-gradient(to left, var(--primitive-gray-300) 42%, var(--primitive-gray-700) 120%)',
        text: 'var(--primitive-black-40)'
    }
};

export const strip = styled.div<{$color: StatusColor}>`
    ${dFlexCenter};
    gap: ${({$color}) => ($color === 'scanned' || $color === 'canceled' || $color === 'past' ? '0' : 'var(--space-sm)')};
    width: 100%;
    height: ${statusStripHeight};
    overflow: hidden;
    padding-left: ${({$color}) => ($color === 'scanned' ? 'var(--dimension-8)' : '0')};
    background: ${({$color}) => statusStripPalette[$color].bg};
    color: ${({$color}) => statusStripPalette[$color].text};
    font-size: var(--font-size-heading-card);
    font-weight: var(--font-weight-bold);
`;

export const details = styled.span`
    font-variant-numeric: tabular-nums;
`;

export const image = styled.img<{$shiftY?: string; $height?: string; $rotate?: string; $desaturate?: boolean}>`
    flex: none;
    height: ${({$height}) => $height || '63px'};
    width: auto;
    object-fit: contain;
    transform: ${({$shiftY, $rotate}) => [$shiftY && `translateY(${$shiftY})`, $rotate && `rotate(${$rotate})`].filter(Boolean).join(' ') || 'none'};
    filter: ${({$desaturate}) => ($desaturate ? 'grayscale(0.96)' : 'none')};
`;
